import Segment from '@/creditflowresearch/domain/Segment/Segment';
import { MarketSegment } from '@/creditflowresearch/domain/Market/types/MarketSegment';
import { CORP_SEGMENT_ID } from '@/creditflowresearch/domain/Segment/constants';

class CorpSegment extends Segment {
  static readonly SEGMENT_ID: string = CORP_SEGMENT_ID;

  static readonly TYPE: MarketSegment = MarketSegment.CORP;
}

export default CorpSegment;
